export const userActionTypes = {
  SET_ALL_JOBS: "SET_ALL_JOBS",
};
